import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { default as Wallboard } from '../wallboard/wallboard.module.ajs';
import { IndicatorList, WallboardList } from './';
import { WallboardConfRouter } from './wallboard-conf-router';

export default module('contact.wallboard.configuration', [Wallboard, IndicatorList, WallboardList]).factory(
  'wallboardConfRouter',
  downgradeInjectable(WallboardConfRouter)
).name;
